<template>
  <b-form-group v-if="show" class="mb-2">
    <div class="block-tiles">
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'hero' ? 'active' : '')"
        @click.prevent="onChange('hero')"
        v-b-tooltip.hover 
        :title="trans('block_hero')"
      >
        <i class="fa fa-fw fa-image full"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'one-column' ? 'active' : '')"
        @click.prevent="onChange('one-column')"
        v-b-tooltip.hover 
        :title="trans('block_one_column')"
      >
        <i class="fa fa-fw fa-align-justify full"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'button' ? 'active' : '')"
        @click.prevent="onChange('button')"
        v-b-tooltip.hover 
        :title="trans('button')"
      >
        <i class="fa fa-fw fa-window-minimize full" style="line-height: 1px;"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'image-column' ? 'active' : '')"
        @click.prevent="onChange('image-column')"
        v-b-tooltip.hover 
        :title="trans('block_image_column')"
      >
        <i class="fa fa-fw fa-image half"></i>
        <i class="fa fa-fw fa-align-justify half"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'column-image' ? 'active' : '')"
        @click.prevent="onChange('column-image')"
        v-b-tooltip.hover 
        :title="trans('block_column_image')"
      >
        <i class="fa fa-fw fa-align-justify half"></i>
        <i class="fa fa-fw fa-image half"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'spacer' ? 'active' : '')"
        @click.prevent="onChange('spacer')"
        v-b-tooltip.hover 
        :title="trans('block_spacer')"
      >
        <i class="fa fa-fw fa-grip-lines full"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'two-columns' ? 'active' : '')"
        @click.prevent="onChange('two-columns')"
        v-b-tooltip.hover 
        :title="trans('block_two_columns')"
        v-if="!id || subtype == 'two-columns'"
      >
        <i class="fa fa-fw fa-align-justify half"></i>
        <i class="fa fa-fw fa-align-justify half"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'video' ? 'active' : '')"
        @click.prevent="onChange('video')"
        v-b-tooltip.hover 
        :title="trans('block_video')"
      >
        <i class="fa fa-fw fa-film full"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'video-column' ? 'active' : '')"
        @click.prevent="onChange('video-column')"
        v-b-tooltip.hover 
        :title="trans('block_video_column')"
      >
        <i class="fa fa-fw fa-film half"></i>
        <i class="fa fa-fw fa-align-justify half"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'zoom' ? 'active' : '')"
        @click.prevent="onChange('zoom')"
        v-b-tooltip.hover 
        :title="trans('block_zoom')"
      >
        <i class="fa fa-fw fa-video full"></i>
      </a>
      <a href="#"
        :class="'block-tile m-2 ' + (subtype == 'paper' ? 'active' : '')"
        @click.prevent="onChange('paper')"
        v-b-tooltip.hover 
        :title="trans('block_paper')"
      >
        <i class="fa fa-fw fa-certificate full"></i>
      </a>
    </div>
    <label class="mt-2">{{ subtype == 'button' ? trans('button') : trans('block_'+subtype.replace('-', '_')) }}</label>
  </b-form-group>
</template>

<script>
  export default {
    props: {
      organization: Object,
      value: String,
      id: Number,
      tab: Number,
      show: Boolean,
    },
    data() {
      return {
        trans: trans,
        subtype: this.value,
      }
    },
    methods: {
      onChange(subtype) {
        this.subtype = subtype
        let type = subtype == 'button' ? 'one-column' : subtype
        let tab = subtype == 'button' ? 1 : 0
        this.$emit('input', type)
        this.$emit('tab', 0)
        setTimeout(() => {
          this.$emit('tab', tab)
        }, 500)
      },
    },
    mounted() {
      window.blockTiles = this
    },
  }
</script>